import React, { useContext, Component } from "react";
import { GlobalStateContext } from "./App";
import DataCampus from "./campus";


function CursoInfo({ cursos }) {
    return (

        <div>
            {cursos.map((val, index) => (
                <div key={index}>
                    <h2 className="title">{val.nombre_programa}</h2>
                    {/* <p><b>Facultad:</b> {val.facultad}</p>
                    <p><b>Nivel:</b> {val.nivel}</p> */}
                    <br />
                    <CampusInfo data={val.campus_pro} />
                </div>
            ))}
        </div>

    );
}

function CampusInfo({ data }) {

    return (
        <>
            <div className="gsc-grid-posgrados">
                {data.map((val, index) => {
                    const campusData = DataCampus.find(c => c.id === val.id_escuelas);
                    if (!campusData) return null;
                    return (
                        <div key={index} className="thumbnail content-thumbnail">
                            <img className="card-img-top" src={campusData.image} alt={campusData.name} />
                            <div className="caption">
                                <div className="title-3"><h3>{campusData.name}</h3></div>
                                <div> <a target="_blank" href={val.url_prog} className="btn btn-default" rel="noopener" role="button">Ver Más Información</a></div>
                            </div>
                        </div>
                    )

                })
                }
            </div>

        </>
    )
}

export default function ProgramaCurso() {

    const {
        item,
        idProgram,
        setidProgram
    } = useContext(GlobalStateContext);

    const cursoSeleccionado = item.filter((val) => val.id_programa === idProgram);


    if (cursoSeleccionado.length === 0) {
        return <p>No hay datos para este programa.</p>;
    }

    return (
        <div className="container-fluid justify-content-center">
                    <div className="row">

                <div classsName="col-12 aling-right">
                    <button className="btn btn-large text-center" style={{margin:"1rem 0"}} onClick={() => setidProgram(0)}>
                        ← Volver al listado
                    </button>
                </div>
            </div>
            <CursoInfo cursos={cursoSeleccionado}></CursoInfo>
    
        </div>
    );
}
